import { Colors, Img, Lightning, Utils } from "@lightningjs/sdk";
import { BrandingModel, MediaModel } from "../../../lib/models";
import theme from "../../../lib/theme";
import configs from "../../../lib/configs";

interface MovieDetailsCoverTemplateSpec extends Lightning.Component.TemplateSpec {
    textureSrc?: string;
    Placeholder: object;
    Image: object;
}

export class MovieDetailsCover
    extends Lightning.Component<MovieDetailsCoverTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<MovieDetailsCoverTemplateSpec>
{
    _boundEventHandler?: any;
    _data!: MediaModel | BrandingModel;

    static override _template(): Lightning.Component.Template<MovieDetailsCoverTemplateSpec> {
        return {
            // w: this._w,
            // h: this._h,
            w: theme.mediaItem.w,
            h: theme.mediaItem.h,
            flexItem: { marginRight: 34 },
            Placeholder: {
                mount: 0.5,
                w: (w) => w - 40,
                h: (h) => h - 40,
                x: (w) => w / 2,
                y: (y) => y / 2,
                texture: Img(Utils.asset("images/placeholder.png")).contain(theme.mediaItem.w, theme.mediaItem.h)
            },
            Image: {
                w: (w) => w,
                h: (h) => h,
                alpha: 0.01,
                flexItem: { marginRight: 34 },
                src: undefined,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: theme.mediaItem.border.radius }
            }
        };
    }

    readonly CoverImage = this.getByRef("Image")!;

    override _setup() {
        this._boundEventHandler = this._showPoster.bind(this);
    }

    override _active() {
        this.CoverImage.on("txLoaded", this._boundEventHandler);
    }

    override _inactive() {
        this.CoverImage.off("txLoaded", this._boundEventHandler);
    }

    _showPoster() {
        this.CoverImage?.setSmooth("alpha", 1);
    }

    set textureSrc(texture: string) {
        this.CoverImage.patch({
            src: `${texture}${configs.appId != "skyvod" ? `?width=${this.w}` : `/${this.w}x${this.h}_fit.jpg`}`
        });
    }
}
